{
  "dashboardTitle": "Notifications",
  "dashboardSubtitle": "Monitor email and SMS delivery status",
  "allEmails": "All Emails",
  "allSms": "All SMS",
  "emailPending": "Email Pending",
  "smsPending": "SMS Pending",
  "failedToday": "Failed Today",
  "deliveredToday": "Delivered Today",
  "recentEmails": "Recent Emails",
  "recentSms": "Recent SMS",
  "viewAll": "View All",
  "viewDetail": "View Detail",
  "noRecentEmails": "No recent emails",
  "noRecentSms": "No recent SMS messages",
  "loading": "Loading...",
  "breadCrumbs": {
    "notifications": "Notifications"
  }
}
